module.exports = __webpack_public_path__ + "img/em10.152dc992.jpg";